module.exports = __webpack_public_path__ + "static/media/curtain-cleaning-service.a7458bff.png";